export const UserNotificationType = {
    "DAILY_MENU_SMS": 1,
    "UPCOMING_EVENT_SMS": 2
}